import { Button, message, Modal } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';

import { REDEEM_CODE_FIELDS } from './RedeemCodeList';

const DESTROY_REDEEM_CODE_MUTATION = gql`
  ${REDEEM_CODE_FIELDS}
  mutation destroyRedeemCode($id: Int!) {
    destroyRedeemCode(id: $id) {
      ...redeemCodeFields
    }
  }
`;

interface Props {
  redeemCodeId: number;
}
interface State {
  isDestroyRedeemCodePopupConfirmVisible: boolean;
}

export class DestroyRedeemCode extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isDestroyRedeemCodePopupConfirmVisible: false,
    };
  }

  distroyRedeemCodeConfirm = () => {
    this.setState({ isDestroyRedeemCodePopupConfirmVisible: true });
  };

  render() {
    return (
      <div>
        <Button size="small" type="primary" onClick={() => this.distroyRedeemCodeConfirm()}>
          作废
        </Button>
        <Mutation
          mutation={DESTROY_REDEEM_CODE_MUTATION}
          variables={{
            id: this.props.redeemCodeId,
          }}
        >
          {(destroyRedeemCode, { loading }) => {
            return (
              <Modal
                title="兑换码作废"
                visible={this.state.isDestroyRedeemCodePopupConfirmVisible}
                onOk={async () => {
                  if (loading) {
                    return;
                  }
                  try {
                    await destroyRedeemCode();
                    message.success('操作成功！');
                  } catch (e) {
                    message.error('操作失败！');
                  }
                }}
                onCancel={() => {
                  this.setState({ isDestroyRedeemCodePopupConfirmVisible: false });
                }}
              >
                <p>兑换码作废后，无法使用！是否作废？</p>
              </Modal>
            );
          }}
        </Mutation>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/redeemCode/destroyRedeemCode.tsx